// HACKATHON: Add crypto endpoints
// Add these to your useMarketData_v2.js or use separately

import { useState, useEffect } from 'react';

const API_BASE_PYTHON = '/api/py82/api';

export const usePythonAPIData = (endpoint, interval = 30000) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch(`${API_BASE_PYTHON}${endpoint}`);
        const json = await res.json();
        setData(json);
        setLoading(false);
      } catch (err) {
        console.error(`Error fetching ${endpoint}:`, err);
        setLoading(false);
      }
    };

    fetchData();
    const timer = setInterval(fetchData, interval);
    return () => clearInterval(timer);
  }, [endpoint, interval]);

  return { data, loading };
};

// Crypto endpoints
export const useCryptoTop = () => usePythonAPIData('/crypto_coins', 60000); // Top coins, 1min refresh
export const useCryptoAll = () => usePythonAPIData('/all_crypto_coins', 60000); // All coins, 1min refresh
